


































































































import { Component, Vue } from 'vue-property-decorator'
import { Auth } from '@finx/web-repository/src/services/Oidc'
import useHospitais from '@/composables/useHospitais/useHospitais'

@Component
export default class SuportePersonificar extends Vue {
  loginUsuario = ''
  carregandoAcesso = false
  carregandoLogout = false
  erro = ''
  readyState = false
  usuarioPersonificado: any = null
  usuarioAtor: any = {}

  mounted() {
    // Recolher o menu lateral para dar mais espaço à tela de personificação
    this.$store.commit('BackofficeNavigationStore/setMiniSync', true)
    localStorage.setItem('miniSync', 'true')

    const impersonationData = sessionStorage.getItem('IMPERSONATION_USER')
    const actorData = sessionStorage.getItem('IMPERSONATION_ACTOR')
    if (sessionStorage.getItem('IMPERSONATION_ACTIVE') === 'true' && impersonationData) {
      try {
        this.usuarioPersonificado = JSON.parse(impersonationData)
      } catch (e) {
        this.usuarioPersonificado = {}
      }
      try {
        this.usuarioAtor = actorData ? JSON.parse(actorData) : {}
      } catch (e) {
        this.usuarioAtor = {}
      }
    }
    this.readyState = true
  }

  get emailPreview() {
    const u = (this.loginUsuario || '').trim()
    return u ? `${u}@finxapp.com.br` : '@finxapp.com.br'
  }

  normalizarLogin(val: string) {
    if (!val) return
    const atIdx = val.indexOf('@')
    if (atIdx !== -1) {
      this.loginUsuario = val.slice(0, atIdx)
    }
  }

  async fazerLogout() {
    this.carregandoLogout = true
    try {
      sessionStorage.removeItem('IMPERSONATION_ACTIVE')
      sessionStorage.removeItem('IMPERSONATION_USER')
      sessionStorage.removeItem('IMPERSONATION_ACTOR')
      sessionStorage.removeItem('IMPERSONATION_IN_PROGRESS')
      sessionStorage.removeItem('IMPERSONATION_REDIRECT')

      // Limpa o cache de hospitais do usuario personificado para que o operador
      // volte a ver seus proprios hospitais ao sair da personificacao.
      useHospitais.reset()

      try {
        await Auth.userManager.removeUser()
      } catch (e) {
        // ignorar se falhar
      }

      Auth.login('/suporte/personificar')
    } catch (e) {
      this.carregandoLogout = false
    }
  }

  async chamarTokenExchange(requestedSubject: string, accessToken: string) {
    try {
      const { TOKEN_EXCHANGE_URL } = window as any
      const response = await fetch(`${TOKEN_EXCHANGE_URL}?email=${requestedSubject}`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })

      return response
    } catch (error) {
      const err = error as any
      throw new Error(`Falha ao chamar API de Token Exchange: ${err.message || error}`)
    }
  }

  async acessar() {
    if (!this.loginUsuario || !this.loginUsuario.trim()) {
      this.erro = 'Informe o usuário'
      return
    }

    const email = this.loginUsuario.trim().toLowerCase() + '@finxapp.com.br'

    this.carregandoAcesso = true
    this.erro = ''

    try {
      const user = await Auth.userManager.getUser()
      if (!user || !user.access_token) {
        Auth.login('/suporte/personificar')
        return
      }

      const tokenResponse = await this.chamarTokenExchange(email, user.access_token)

      if (!tokenResponse.ok) {
        if (tokenResponse.status === 401) {
          Auth.login('/suporte/personificar')
          return
        }
        const errorData = await tokenResponse.json().catch(() => null)
        this.erro = (errorData && errorData.message) || 'Não foi possível personificar o usuário. Tente novamente.'
        return
      }

      const tokenData = await tokenResponse.json()

      const keycloakUrl = (window as any).KEYCLOAK_AUTHORITY_URL
      const realm = (window as any).KEYCLOAK_REALM
      const clientId = (window as any).KEYCLOAK_CLIENT_ID

      const finalTokens = {
        access_token: tokenData.access_token,
        refresh_token: tokenData.refresh_token,
        expires_in: tokenData.expires_in,
        token_type: tokenData.token_type,
        id_token: tokenData.id_token,
        session_state: tokenData.session_state || user.session_state,
        scope: tokenData.scope || user.scope || 'openid profile email',
      }

      let userProfile: any = null
      try {
        const tokenParts = finalTokens.access_token.split('.')
        if (tokenParts.length === 3) {
          const base64 = tokenParts[1].replace(/-/g, '+').replace(/_/g, '/')
          const jsonStr = decodeURIComponent(
            atob(base64).split('').map((c: string) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
          )
          const payload = JSON.parse(jsonStr)
          userProfile = {
            sub: payload.sub,
            preferred_username: payload.preferred_username,
            name: payload.name,
            email: payload.email,
            given_name: payload.given_name,
            family_name: payload.family_name,
            email_verified: payload.email_verified,
          }
        }
      } catch (decodeError) {
        const err = decodeError as any
        this.erro = `Falha ao decodificar token: ${err.message}`
        return
      }

      if (!userProfile) {
        this.erro = 'Não foi possível obter informações do usuário do token'
        return
      }

      const { API_SEGURANCA } = window as any

      const userRolesResponse = await fetch(`${API_SEGURANCA}/usuarios/roles`, {
        headers: {
          Authorization: `Bearer ${finalTokens.access_token}`,
        },
      })

      let userData = null
      if (userRolesResponse.ok) {
        const rolesData = await userRolesResponse.json()
        userData = rolesData.data
      }

      if (userData && userProfile) {
        const profile = userProfile as any
        const data = userData as any
        profile.roles = data.legacyRoles || []
        profile.pageAuthorized = data.legacyPageAuthorized || []
        profile.permissoes = data.permissoesExtras || []
        profile.defaultPage = data.defaultPage || { view: '', keyAuthorized: '' }

        if (typeof profile.defaultPage === 'string') {
          try {
            profile.defaultPage = JSON.parse(profile.defaultPage)
          } catch (e) {
            profile.defaultPage = { view: '', keyAuthorized: '' }
          }
        }
      }

      const authority = `${keycloakUrl}/realms/${realm}`
      const storageKey1 = `oidc.user:${authority}:${clientId}`
      const storageKey2 = `oidc.user:${keycloakUrl}/:portal-client-2`

      const now = Math.floor(Date.now() / 1000)
      const expiresAt = now + (finalTokens.expires_in || 3600)

      const oidcUser = {
        id_token: finalTokens.id_token,
        session_state: finalTokens.session_state || user.session_state,
        access_token: finalTokens.access_token,
        refresh_token: finalTokens.refresh_token,
        token_type: finalTokens.token_type || 'Bearer',
        scope: finalTokens.scope || user.scope,
        profile: userProfile,
        expires_at: expiresAt,
      }

      if (this.$store.commit) {
        this.$store.commit('addToastMessage', {
          type: 'success',
          message: `Personificando como: ${userProfile.name || email}`,
        })
      }

      await new Promise(resolve => setTimeout(resolve, 500))

      const defaultPage = userProfile && (userProfile as any).defaultPage
      let redirectUrl = (window as any).setDefaultRoute(defaultPage)

      if (redirectUrl === '/navigation-not-allowed') {
        redirectUrl = '/perfil'
      }

      sessionStorage.setItem('IMPERSONATION_IN_PROGRESS', 'true')

      localStorage.setItem(storageKey1, JSON.stringify(oidcUser))
      localStorage.setItem(storageKey2, JSON.stringify(oidcUser))

      localStorage.removeItem('vuex')
      localStorage.removeItem('miniSync')
      localStorage.removeItem('lastUser')

      // Zera o cache de hospitais do operador. A personificacao troca o usuario
      // por navegacao SPA (sem reload), entao sem isso o dropdown continuaria
      // exibindo os hospitais do operador em vez dos do usuario personificado.
      useHospitais.reset()

      const check1 = localStorage.getItem(storageKey1)
      const check2 = localStorage.getItem(storageKey2)

      if (!check1 || !check2) {
        this.erro = 'Erro ao salvar dados de personificação'
        return
      }

      sessionStorage.setItem('IMPERSONATION_ACTIVE', 'true')
      sessionStorage.removeItem('IMPERSONATION_IN_PROGRESS')
      sessionStorage.setItem('IMPERSONATION_USER', JSON.stringify({
        sub: userProfile.sub,
        name: userProfile.name,
        email: userProfile.email,
      }))
      sessionStorage.setItem('IMPERSONATION_ACTOR', JSON.stringify({
        sub: user.profile.sub,
        name: user.profile.name,
        email: user.profile.email,
      }))
      sessionStorage.setItem('IMPERSONATION_REDIRECT', redirectUrl)

      const userForVue = {
        accessToken: oidcUser.access_token,
        expiresAt: oidcUser.expires_at,
        idToken: oidcUser.id_token,
        refreshToken: oidcUser.refresh_token,
        scope: oidcUser.scope,
        sessionState: oidcUser.session_state,
        tokenType: oidcUser.token_type,
        profile: oidcUser.profile,
      }

      this.$user = userForVue as any

      setTimeout(() => {
        this.$router.push(redirectUrl)
      }, 100)
    } catch (error) {
      const err = error as any

      if (err.name === 'TypeError' && err.message.includes('fetch')) {
        this.erro = 'Erro de conexão. Verifique sua rede e tente novamente.'
      } else {
        this.erro = err.message || 'Erro inesperado ao personificar usuário.'
      }
    } finally {
      this.carregandoAcesso = false
    }
  }

}
